import React, { useState } from "react";
import Modal from "components/UI/DialogModal";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Autocomplete,
} from "@mui/material";
import MuiButton from "components/UI/MuiButton";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import { ITopic } from "models/topic";
import { ICompanyTopic, ICompanyTopicInput } from "models/companyTopics";



interface Props {
  open: boolean;
  loading: boolean;
  topics: ITopic[];
  selectedTopic:ICompanyTopic
  onClose: () => void;
  onSubmit: (data: ICompanyTopicInput) => void;
}





const EditCompanyTopic: React.FC<Props> = ({
  open,
  loading,
  selectedTopic,
  topics,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const [name, setName] = useState<string>(selectedTopic.name || "");
  const [nameAr, setNameAr] = useState<string>(selectedTopic.nameAr || "");

  const topicsEnglishOptions = topics.map((topic) => ({
    value: topic.id,
    label: topic.name,
  }));

  const topicsArabicOptions = topics.map((topic) => ({
    value: topic.id,
    label: topic.nameAr,
  }));

  const handleTitleChange = (newValue: string | null) => {
    setName(newValue || "");

    const selectedTopic = topics.find((topic) => topic.name === newValue);
    if (selectedTopic) {
      setNameAr(selectedTopic.nameAr);

    } else {
      setNameAr("");

    }
  };

  const handleTitleArChange = (newValue: string | null) => {
    setNameAr(newValue || "");

    const selectedTopic = topics.find((topic) => topic.nameAr === newValue);
    if (selectedTopic) {
      setName(selectedTopic.name);

    } else {
      setName("");
  
    }
  };





  const clearFields = () => {
    setName("");
    setNameAr("");
  
  };


  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={t("T_edit_topic")}
        maxWidth="lg"
        children={
          <Stack spacing={2} p={2}>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <Autocomplete
                  freeSolo
                  options={topicsEnglishOptions.map((option) => option.label)}
                  style={{minWidth:'300px'}}
                  value={name}
           
                  onChange={(event, newValue) => handleTitleChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("T_title")}
                      variant="outlined"
                      onChange={(e) => setName(e.target.value)}
                   
                    />
                  )}
                />

                <Autocomplete
                  freeSolo
                  options={topicsArabicOptions.map((option) => option?.label || '')}
                  style={{minWidth:'300px'}}
                  value={nameAr}
               
                  onChange={(event, newValue) => handleTitleArChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("T_title_Ar")}
                      variant="outlined"
                      onChange={(e) => setNameAr(e.target.value||'')}
                  
                    />
                  )}
                />

                {/* <Button
                  variant="contained"
                  style={{ borderRadius: 0 }}
                  onClick={addEntry}
                  disabled={
                    !title || !titleAr
                  }
                >
                  {t("T_add")}
                </Button> */}

                <Button
                  variant="outlined"
                  style={{ borderRadius: 0 }}
                  onClick={clearFields}
                >
                  {t("T_clear")}
                </Button>

              </div>

           
            </div>
          </Stack>
        }
        actions={
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
            px={1}
          >
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "warning.main", color: "white" }}
              size="large"
              onClick={onClose}
            >
              {t("T_cancel")}
            </MuiButton>
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "primary.main", color: "white" }}
              disabled={loading || !name || !nameAr}
              size="large"
              onClick={() => onSubmit({name,nameAr})}
            >
              {t("T_add")}
              <CircularProgress
                size={10}
                sx={{ mx: 2, display: loading ? "" : "none" }}
              />
            </MuiButton>
          </Grid>
        }
      />
    </>
  );
};

export default EditCompanyTopic;
